import * as Yup from "yup";

export const countryValidationSchema = Yup.object().shape({
  country_name: Yup.string()
    .trim()
    .min(2, "Country name must be at least 2 characters")
    .max(100, "Country name cannot exceed 100 characters")
    .required("Country name is required"),

  country_code: Yup.string()
    .trim()
    .matches(/^[A-Z]{2}$/, "Country code must be exactly 2 uppercase letters")
    .required("Country code is required"),

  iso3_code: Yup.string()
    .trim()
    .matches(/^[A-Z]{3}$/, "ISO3 code must be exactly 3 uppercase letters")
    .required("ISO3 code is required"),
});
